
import { useNavigate, useParams } from "react-router-dom";
import PageHeaderProps from "../../../../model/PageHeaderProps";
import { useAppDispatch, useAppSelector } from "../../../../store/store";
import Container from "../../../layout/Container";
import Header from "../../../layout/Header";
import PageContainer from "../../../layout/PageContainer";
import { useEffect, useState } from "react";
import Client from "../../../../model/Client";
import ClientContact from "../../../../model/ClientContact";
import EditClientForm from "../../../elements/Client/EditClientForm";
import { State } from "../../../../model/address";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import { createClient, resetCreateFailure } from "../../../../store/actions/clientActions";
import { createFailureSelector, creatingClientSelector, saveSuccessSelector } from "../../../../store/selectors/clientSelector";
import LoadingOverlay from "../../../elements/LoadingOverlay";

const blankClient: Client = {
    code: "",
    clientId: -1,
    name: "",
    addressLine1: "",
    addressLine2: "",
    addressLine3: "",
    postCode: "",
    abn: "",
    contacts: []
}

const CreateClientPage: React.FC<PageHeaderProps> = ({isNavOpen, setIsNavOpen}) => {      
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [editClient, setEditClient] = useState<Client>({...blankClient});    
    const [canSave, setCanSave] = useState<boolean>(false);
    const [newContacts, setNewContacts] = useState<ClientContact[]>([]);
    
    const isCreating = useAppSelector(creatingClientSelector);
    const wasSuccessful = useAppSelector(saveSuccessSelector);
    const wasUnsuccessful = useAppSelector(createFailureSelector);

    useEffect(() => {
        if(wasUnsuccessful){
            dispatch(resetCreateFailure());        
        }
    }, []);

    useEffect(() => {
        if(editClient === null) {
            navigate(-1)
        }
    }, [navigate, editClient ]);

    if(wasSuccessful) {
        navigate("/portal/clients")
    }

    if(wasUnsuccessful){
        setTimeout(() => {
            dispatch(resetCreateFailure());
        }, 5000)
    }

    const handleSave = () => {
        dispatch(createClient({
            ...editClient,
            contacts: [
                ...editClient.contacts,
                ...newContacts
            ]
        }))
    }

    return <PageContainer>
    <Header title={"Clients"} isNavOpen={isNavOpen} setIsNavOpen={setIsNavOpen} showBack={true} />
    <Container style={{ padding: "1rem" }}>
        {wasUnsuccessful &&
            <Alert color="error">Failed to save client - Either the client code already exists or there are issues connecting to the API. Please try again shortly or try a different client code. </Alert>
        }
        {editClient !== null && <>
                <Box display="flex" justifyContent="space-between">
                    <h2 style={{ margin: "1rem 0 2rem 0"}}>Create Client</h2>
                    <Button disabled={!canSave} variant="contained" sx={{ margin: "1rem"}} onClick={handleSave}>Save</Button> 
                </Box>
                <EditClientForm ogClient={{...blankClient}} 
                    editClient={editClient} 
                    setEditClient={setEditClient} 
                    newContacts={newContacts} 
                    setNewContacts={setNewContacts} 
                    setCanSave={setCanSave} 
                />     
                 <Box display="flex" justifyContent="space-between">                    
                    <Button disabled={!canSave} variant="contained" sx={{ margin: "1rem"}} onClick={handleSave}>Save</Button> 
                </Box>                  
            </>
        }

        {isCreating &&
            <LoadingOverlay text="Creating Client..."/>
        }
        
    </Container>
</PageContainer>
}

export default CreateClientPage;